import { nanoid } from 'nanoid';
import { signout } from '@features/common';
import {
  $notification,
  hideNotification,
  notificationUnmounted,
  showErrorNotification,
  showInfoNotification,
  showSuccessNotification,
  showWarningNotification,
} from './notification.model';

$notification
  .on(showSuccessNotification, (_, payload) => ({
    ...payload,
    id: nanoid(),
    severity: 'success',
    variant: 'filled',
  }))
  .on(showInfoNotification, (_, payload) => ({
    ...payload,
    id: nanoid(),
    severity: 'info',
    variant: 'filled',
  }))
  .on(showWarningNotification, (_, payload) => ({
    ...payload,
    id: nanoid(),
    severity: 'warning',
    variant: 'filled',
  }))
  .on(showErrorNotification, (_, payload) => ({
    ...payload,
    id: nanoid(),
    severity: 'error',
    variant: 'filled',
  }))
  .on(hideNotification, (state, payload) => (state?.id === payload.id ? null : state))
  .reset([notificationUnmounted, signout]);
